<template>
  <div :class="['cmp', 'cmp-tab-task']">
    <div class="body">
      <template v-for="(v, i) in modelsDict[0]">
        <cmpFrame
          v-if="['RESOURCE'].includes(v.type) && v.resource"
          class="mod"
          :key="i"
          :label="v.resource.name"
          :studyRequest="v.resource.studyRequest"
        >
          <iframe
            allowfullscreen
            :src="
              `${documentViewer}${resourceInfoDict[v.resource.resourceKey]}&format=${getSuffix(
                v.resource.resourceKey
              )}&imgSize=auto&autoplay=false`
            "
          ></iframe>
        </cmpFrame>
        <div :style="{ marginBottom: '30px' }" v-else-if="['TEXT'].includes(v.type)" class="mod mod-1" :key="i">
          <p v-html="(v.text || {}).content || ''"></p>
        </div>
      </template>
    </div>
    <cmpMenu
      ref="cmpMenu"
      class="mod cmpMenu"
      v-show="modelsDict[1].length"
      :setActiveIndex="menuActive.cmpMenuIndex || -1"
      :data="modelsDict[1]"
      @change="menuChange"
    ></cmpMenu>
    <component :is="componentsDict[menuActiveIndex]" :data="menuActive"></component>
    <div v-if="models.length === 0" class="nodata nodata-default">暂无数据</div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cmpFrame from "@/components/cmpFrame.vue";
import cmpMenu from "@/components/cmpMenu.vue";
// import tab2Zttl from "./tab2-zttl.vue";
// import tab2Znlt from "./tab2-znlt.vue";
import tab2Ktxc from "./tab2-ktxc.vue";
import tab2dypj from "./tab2-dypj.vue";
// import tab2Ktwj from "./tab2-ktwj.vue";
// import tab2Ktzy from "./tab2-ktzy.vue";
import publicUrl from "@/assets/js/interface";

export default {
  name: "cmp-tab-task",
  components: {
    cmpFrame,
    cmpMenu,
    // tab2Zttl,
    // tab2Znlt,
    tab2Ktxc,
    tab2dypj,
    // tab2Ktwj,
    // tab2Ktzy,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      taskDetails: {},
      menuActive: {},
      menuActiveIndex: "",
      documentViewer: "https://component-pub.jsxfedu.com/document-viewer/index.html?url=",
      componentsDict: {
        EVALUATE: "tab2dypj",
        SUBJECT_DISCUSSION: "tab2Zttl",
        CLASSROOM_TEST: "tab2Ktxc",
        CLASSROOM_QUESTION: "tab2Ktwj",
        GROUP_CHITCHAT: "tab2Znlt",
        CLASSROOM_JOB: "tab2Ktzy",
      },
    };
  },
  computed: {
    ...mapState({
      resourceInfoDict: "resourceInfoDict",
      messageParams: "messageParams",
    }),
    models() {
      return this.taskDetails.models || [];
    },
    messageModelsDict() {
      // message 跳转过来需要的数据格式
      let result = {};
      this.models.forEach((v, i) => {
        if (["RESOURCE", "TEXT"].includes(v.type)) {
          return false;
        } else {
          if (v.type === "CLASSROOM_TEST") {
            this.$set(result, v.type + v.modelChildId, { ...v, cmpMenuIndex: i });

            // result[v.type] = { ...v, cmpMenuIndex: i };
          } else {
            this.$set(result, v.type + "===" + v.evaluate.type, { ...v, cmpMenuIndex: i });

            // result[v.type + "===" + v.evaluate.type] = { ...v, cmpMenuIndex: i };
          }
        }
      });
      return result;
    },
    modelsDict() {
      let result = { 0: [], 1: [] };
      this.models.forEach((v) => {
        if (["RESOURCE", "TEXT"].includes(v.type)) {
          result[0].push(v);
        } else {
          result[1].push(v);
        }
      });
      return result;
    },
    queryData() {
      return this.$route.query;
    },
  },

  mounted() {
    this.getTaskDetails();
  },
  methods: {
    ...mapActions(["resourceInfoGetter"]),
    menuChange(item) {
      this.menuActive = item || {};
      this.menuActiveIndex = item.type;
    },
    getTaskDetails() {
      this.loadingCount++;
      this.taskDetails = {};
      this.$ajax
        .get(publicUrl.taskDetails, {
          params: {
            taskId: this.$route.query.taskId,
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.taskDetails = res.data.data || {};
            if (this.messageParams.messageType) {
              this.$nextTick(() => {
                document.documentElement.scrollTop = document.querySelector(".cmpMenu").offsetTop - 100;

                // message 消息跳转过来的type区分
                let queryData = this.messageParams;
                this.menuActive =
                  queryData.messageType === "EVALUATE"
                    ? this.messageModelsDict[queryData.messageType + "===" + queryData.subType]
                    : this.messageModelsDict[queryData.messageType + queryData.relatedId];
                this.menuActiveIndex = queryData.messageType;
              });
            } else {
              if (this.modelsDict[1].length) {
                this.menuActive = this.modelsDict[1][0] || {};
                this.menuActiveIndex = this.modelsDict[1][0].type;
              }
            }
            let fileNames = [];
            this.models.forEach((v) => {
              if (["RESOURCE"].includes(v.type)) {
                if ((v.resource || {}).resourceKey) {
                  fileNames.push((v.resource || {}).resourceKey);
                }
              }
            });
            fileNames = fileNames.filter((v) => !!v);
            this.resourceInfoGetter({ vm: this.$root, fileNames });
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    getSuffix(key) {
      return (key || "").split(".").pop() || "";
    },
  },
};
</script>

<style lang="less">
.cmp-tab-task {
  .body {
    // background-image: linear-gradient(#ecf5fb, #ffffff);
    // padding: 53px 30px;
    border-radius: 20px;
  }
  .mod {
    // margin-bottom: 15px;
  }

  .mod-1 {
    div[data-w-e-type="video"] {
      text-align: center;
    }
    // p {
    //   font-size: 16px;
    //   color: #464c5b;
    //   font-family: PingFangSC-Regular, PingFang SC;
    //   font-weight: 400;
    //   color: #464c5b;
    //   line-height: 30px;
    // }
    // img {
    //   // display: block;
    //   // width: 1140px;
    //   // height: 338px;
    //   // background: #e8e8e8;
    //   border-radius: 6px;
    // }
    // video {
    //   width: 100%;
    // }
    // b {
    //   font-weight: bold;
    // }
  }
}
</style>
